const itemsOnPage = [10, 20, 30].map(item => ({
  key: item,
  value: item,
  renderElement: item,
  selectedRenderElement: item,
  active: item === 10,
}));

const customRequestStatusesEnums = {
  created: 'created',
  approved: 'approved',
  rejected: 'rejected',
};

const customRequestStatuses = [
  {
    name: 'pending',
    value: customRequestStatusesEnums.created,
    active: true,
  },
  {
    name: 'approved',
    value: customRequestStatusesEnums.approved,
    active: true,
  },
  {
    name: 'rejected',
    value: customRequestStatusesEnums.rejected,
    active: true,
  },
];

const customRequestTypesEnums = {
  all: 'all',
  providers: 'provider',
  game: 'game',
  socialMedia: 'social_link',
  notifications: 'notification',
};

const customRequestTypes = [
  {
    name: 'all',
    value: customRequestTypesEnums.all,
  },
  {
    name: 'provider',
    value: customRequestTypesEnums.providers,
  },
  {
    name: 'game',
    value: customRequestTypesEnums.games,
  },
  {
    name: 'socialMedia',
    value: customRequestTypesEnums.socialMedia,
  },
  {
    name: 'notification',
    value: customRequestTypesEnums.notifications,
  },
];

export { itemsOnPage, customRequestTypes, customRequestStatuses, customRequestStatusesEnums, customRequestTypesEnums };
